import { useMemo } from 'react'
import { Label } from './common/label'
import { useForm } from './form'
import moment from 'moment'

export const FormSimpleDateFormat = ({ name, label, required, placeholder }) => {
  const { getValue } = useForm(name, { required, shouldDirty: true })

  const value = getValue()

  const display = useMemo(() => (value ? moment(value).format('MM-DD-YYYY') : ''), [value])

  return (
    <Label name={name} label={label} required={required}>
      <input className={`form-control bg-secondary-subtle`} value={display} readOnly={true} disabled={true} placeholder={placeholder || label || name} />
    </Label>
  )
}
